import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../../../emotion-theme";

export const PositionDetails = styled.div`
  color: ${BASE_COLORS.grey};
  font-size: ${FONT_SIZES.large};
`;
